"use client"
import { Alert, Button, Group, Text } from "@mantine/core"
import { IconCrown } from "@tabler/icons-react"
import { useTranslations } from "next-intl"
import Link from "next/link"
import { observer, Show, use$ } from "@legendapp/state/react"
import { useModel } from "@/hooks/useModel"
import { useEffect, useRef } from "react"
import { appStore$ } from "@/stores/app.v2.store"
import { syncStore$ } from "@/stores/sync.v2.store"
import { useEngagementTracking } from "@/hooks/useEngagementTracking"

export const TrialBanner = observer(function TrialBanner() {
  const t = useTranslations("TrialBanner")
  const { Account } = useModel()
  const { trackLifecycle } = useEngagementTracking()
  const hasTrackedExpiration = useRef(false)

  const isTrialBannerHidden = use$(appStore$.isTrialBannerHidden)
  const isAdmin = use$(() => {
    const admin = syncStore$.userStatus.isAdmin.get()
    const isOwner = syncStore$.userStatus.isOwner.get()
    return admin || isOwner
  })

  // Track trial expiration when it happens
  useEffect(() => {
    if (Account.trialStatus === "trialExpired" && !hasTrackedExpiration.current) {
      trackLifecycle("trialexpired")
      hasTrackedExpiration.current = true
    }
  }, [Account.trialStatus, trackLifecycle])

  // Update the CSS var in root --header-banner-height by 52px if the trial banner is visible
  useEffect(() => {
    if (
      isAdmin &&
      // (Account.trialStatus === "inTrial" && !isTrialBannerHidden) ||
      Account.trialStatus === "trialExpired" &&
      !isTrialBannerHidden
    ) {
      document.documentElement.style.setProperty("--header-banner-height", "52px")
    } else {
      document.documentElement.style.setProperty("--header-banner-height", "0px")
    }
  }, [Account.trialStatus, isAdmin, isTrialBannerHidden])
  // if (Account.trialStatus === "notInTrial") return null
  // if (isTrialBannerHidden) return null
  // Dont show the trial banner if the user is not an admin
  // although if the trial is expired we will want to show another banner telling the user to ask their admin to upgrade
  if (!isAdmin || Account.trialStatus !== "trialExpired") return null

  return (
    <Alert
      color={"orange.5"}
      variant={"filled"}
      py="sm"
      radius={0}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
      }}
    >
      <Group justify="space-between" w="100%" align="center">
        <Group align="center" gap="md" style={{ flex: 1, justifyContent: "center" }}>
          <Text size="sm">
            <Show if={Account.isSoloFree === false}>
              {() => (
                <Text component="span" fw={500}>
                  {t("expired")}
                </Text>
              )}
            </Show>

            <Show if={Account.isSoloFree === true}>{() => <Text component="span">{t("soloExpired", { resetDate: Account.soloTrialCurrentPeriodResetDate })}</Text>}</Show>

            <Show if={Account.isSoloFree === false}>
              {() => (
                <Text component="span">
                  {t("daysAndMinutesLeft", {
                    days: Account.trialDaysRemaining,
                    minutes: Account.trialMinutesRemaining,
                  })}
                </Text>
              )}
            </Show>

            <Show if={Account.isSoloFree === true}>{() => <Text component="span">{t("soloMinutesLeft", { minutes: Account.soloTrialMinutesRemaining })}</Text>}</Show>
          </Text>
          <Button color={"orange"} size="compact-sm" component={"a"} href="/subscribe" leftSection={<IconCrown size={16} />}>
            <Text size="xs">{t("upgrade")}</Text>
          </Button>
        </Group>
        {/* <Show if={Account.trialStatus === "inTrial"}>
          <CloseButton
            size="sm"
            style={{ marginLeft: "auto" }}
            onClick={() => appStore$.isTrialBannerHidden.set(true)}
          />
        </Show> */}
      </Group>
    </Alert>
  )
})
